module.exports = __webpack_public_path__ + "static/media/4.8d4d3fc1.svg";